import {
  Avatar,
  AvatarGroup,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tooltip,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { ICellRendererParams } from 'ag-grid-community'
import { UserBasic } from '../../../../lib/functions/user'
import { ProgramOverviewDto } from '../../../../infrastructure/api/programs'

const ICON_SIZE = 22

const Wrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
})

// AvatarGroup の「+N」余剰アバターは子 Avatar の sx サイズを継承せず
// デフォルトサイズ(40px)で描画され行高からはみ出すため、グループ側でサイズを統一する
const StyledAvatarGroup = styled(AvatarGroup)({
  '& .MuiAvatar-root': {
    height: `${ICON_SIZE}px`,
    width: `${ICON_SIZE}px`,
    fontSize: '0.75rem',
  },
})

const TooltipBody = styled('div')({
  '& .MuiList-root': { padding: 0 },
  '& .MuiListItem-root': { padding: 0, alignItems: 'center' },
  '& .MuiListItemAvatar-root': {
    height: `${ICON_SIZE}px`,
    minWidth: `${ICON_SIZE}px !important`,
  },
  '& .MuiAvatar-root': {
    margin: '0px 5px 0px 0px',
    height: `${ICON_SIZE}px`,
    width: `${ICON_SIZE}px`,
  },
})

export const CollaboratorsCellRenderer = (
  params: ICellRendererParams<ProgramOverviewDto, UserBasic[]>
) => {
  const collaborators = params.value ?? []
  if (collaborators.length === 0) return null

  return (
    <Tooltip
      title={
        <TooltipBody>
          <List>
            {collaborators.map(c => (
              <ListItem key={c.uuid}>
                <ListItemAvatar>
                  <Avatar src={c.iconUrl ?? undefined} variant="circular" />
                </ListItemAvatar>
                <ListItemText primary={c.name} />
              </ListItem>
            ))}
          </List>
        </TooltipBody>
      }
      placement="bottom-start"
      enterDelay={300}
      enterNextDelay={300}
      leaveDelay={300}
    >
      <Wrapper>
        <StyledAvatarGroup max={6} spacing="medium">
          {collaborators.map(c => (
            <Avatar
              key={c.uuid}
              src={c.iconUrl ?? undefined}
              variant="circular"
            />
          ))}
        </StyledAvatarGroup>
      </Wrapper>
    </Tooltip>
  )
}
